// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ca29e21d","984":"4a4ac9b6"}[chunkId] + ".chunk.js";
};